// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@conklin/MobiusOverrides/Tooltip";
import { wishListSharingStatusStyles } from "@conklin/Overrides/Components/WishListSharingStatus";
import IconListsUser from "@conklin/XDL/Icons/IconListsUser";
import IconNotificationInfo from "@conklin/XDL/Icons/IconNotificationInfo";
import { color, mergeWithCss } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    mergeCss: true,
    iconProps: {
        src: IconNotificationInfo,
        size: 12,
        color: "success.main",
    },
    extendedStyles: {
        triggerWrapper: {
            css: css`
                &&& {
                    margin-right: 6px;
                    margin-left: 0;
                }
            `,
        },
    },
} as TooltipPresentationProps;

wishListSharingStatusStyles.statusText = {
    size: 12,
    lineHeight: "15px",
    css: css`
        display: flex;
        align-items: center;
        > span {
            display: flex;
            align-items: center;
            font-size: 12px;
            line-height: 15px;
        }
    `,
};

wishListSharingStatusStyles.sharedByText = {
    ...mergeWithCss(wishListSharingStatusStyles.statusText, {
        css: css`
            gap: 6px;
        `,
    }),
};

wishListSharingStatusStyles.sharedIcon = {
    src: IconListsUser,
    size: 12,
    color: "success.main",
    css: css`
        margin-right: 5px;
        svg {
            color: ${color("success.main")};
        }
        &:hover {
            svg {
                color: ${color("text.link")};
            }
        }
    `,
};

wishListSharingStatusStyles.autogeneratedTooltip = {
    mergeCss: true,
    iconProps: {
        size: 12,
    },
};
